module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00614.49b4e845.jpg";